import { createFileRoute } from '@tanstack/react-router'

import { Roles } from '@/pages/Settings/Roles/Roles'

export const Route = createFileRoute('/_app/settings/_userManagement/roles')({
  component: Roles,
})
